var React = require('react');

function BottomWiggle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 43.4887C21.0886 30.921 53.7759 16.0332 95.6017 15.2598C167.303 14.0998 194.015 76.7446 275.558 81.3849C355.343 85.832 372.565 29.7609 453.053 25.3139C594.347 17.7733 634.415 203.194 770.788 206.675C922.978 210.542 982.058 7.35778 1120.86 14.2931C1221.03 24.5406 1253.72 101.107 1339.13 98.013C1385.52 96.2728 1418.56 68.8173 1440 43.4887C1440 24.1295 1440 11.0965 1440 0L720 0L0 0L0 43.4887Z","fill":"black"}));
}

BottomWiggle.defaultProps = {"width":"1440","height":"207","viewBox":"0 0 1440 207","fill":"none"};

module.exports = BottomWiggle;

BottomWiggle.default = BottomWiggle;
